import { DataBean } from "../../DataBean";


export class HealthTechnologyType extends DataBean {


    public async getHealthTechnologyTypeCatalog(idState:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthTechnologyTypeCatalog_Number_String_Number_Number", [idState,regexStr,page,recordsPerPage]);
    }


}